import { Box, styled } from "@mui/material";

export const FormContentWrapper = styled(Box)(({ theme }) => ({
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    gap: "70px",
    marginTop:"10px"
}))